// Contatti diretti Mp Digital — aggiorna qui numero WhatsApp ed email
export const WHATSAPP_NUMBER = "393510483229";
export const CONTACT_EMAIL = "info@mpxdigital.it";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -90 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
